module.exports = __webpack_public_path__ + "img/game-logo.54815708.png";